export default "__VITE_ASSET__BSXAIEse__"